module.exports = __webpack_public_path__ + "static/Q2_2025_Investor_Presentation-5ada013a210f0d44525449d30f46c519.pdf";